import { useAuth0 } from '@auth0/auth0-react';
import { Layout } from 'antd';
import imgLogo from 'assets/img/logo.png';
import logo from 'assets/img/omnione_logo_light.svg';
import styles from './AppHeader.module.less';
import HeaderNav from './HeaderNav';
import AvatarDropDowm from './AvatarDropDowm';
import { useHistory } from 'react-router-dom';
import { isInitialSetupCompleted, termsAndConditionsAccepted } from 'utils/userUtils';
import { useSelector } from 'react-redux';
import { userSelector, userTagsSelector } from 'redux/selectors/userSelector';

const { Header } = Layout;

export default function AppHeader() {
	const { user } = useAuth0();
	const history = useHistory();
	const userData = useSelector(userSelector);
	const userTags = useSelector(userTagsSelector);

	if (!user) return null;

	return (
		<Header className={styles.header}>
			<div className={styles.headerLogo} onClick={() => {}}>
				<img src={logo} alt="logo" />
			</div>
			<div className={styles.headerAccount}>
				<AvatarDropDowm user={user} />
			</div>
		</Header>
	);
}
